import React from 'react';
import PropTypes from 'prop-types';

function CardActions(props) {
  const {
    disableActionSpacing,
    children,
    classes,
    className,
    ...other
  } = props;

  return (
    <div className={className} {...other}>
      {children}
    </div>
  );
}

CardActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   * @ignore
   */
  className: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const CardActions = ({prop = val, className = '' }) =>

export default CardActions;
